import React, { Component } from 'react'
import "./Test.css"
import {
  Container,
  Form,
  Button,
  NavLink,
  NavbarBrand
} from 'reactstrap';

class CreateStudy extends Component {
  render() {
    return (
      
      <div>
        <Container className="comming">
          <Form className="boxStudy">
            <h1 className="textStudy1">วิชาประวัติศาสตร์</h1>
            <h5 className="textStudy2">ระดับชั้น ม.1</h5>
            <Form className="bot1">
            <NavLink href='/createStudy1'>หน่วยการเรียนรู้ที่ 1 ช่วงเวลาและวิธีการทางประวัติศาสตร์</NavLink> 
            <NavLink href='/createStudy2'>หน่วยการเรียนรู้ที่ 2 ประวัติศาสตร์เอเชียตะวันออกเฉียงใต้</NavLink>  
            <NavLink href='/createStudy3'>หน่วยการเรียนรู้ที่ 3 เรื่องพัฒนาการทางด้านต่างๆ ของประเทศในภูมิภาคเอเชียตะวันออกเฉียงใต้</NavLink>  
            <NavLink href='/createStudy4'>หน่วยการเรียนรู้ที่ 4 เรื่องสมัยก่อนประวัติศาสตร์ในดินแดนไทย</NavLink> 
            <NavLink href='/createStudy5'>หน่วยการเรียนรู้ที่ 5 เรื่องพัฒนาการและภูมิปัญญาไทยทางด้านการเมืองการปกครองในสมัยสุโขทัย</NavLink>  
            <NavLink href='/createStudy6'>หน่วยการเรียนรู้ที่ 6 เรื่องพัฒนาการและภูมิปัญญาไทยทางด้านเศรษฐกิจในสมัยกรุงสุโขทัย</NavLink>  
            <NavLink href='/createStudy7'>หน่วยการเรียนรู้ที่ 7 เรื่องพัฒนาการและภูมิปัญญาไทยทางด้านสังคมวัฒนธรรมในสมัยสุโขทัย</NavLink>  
            </Form>
            <h5 className="textStudy3">ระดับชั้น ม.2</h5>
            <Form className="bot2">
            
              หน่วยการเรียนรู้ที่ 1 หลักฐานทางประวัติศาสตร์ <br></br>
              หน่วยการเรียนรู้ที่ 2 การสถาปนาอาณาจักรอยุธยาและการเมืองการปกครองสมัยอยุธยา<br></br>
              หน่วยการเรียนรู้ที่ 3 สังคมและเศรษฐกิจสมัยอยุธยา<br></br>
              หน่วยการเรียนรู้ที่ 4 ความสัมพันธ์ระหว่างประเทศสมัยอยุธยา<br></br>
              หน่วยการเรียนรู้ที่ 5 พัฒนาการของอาณาจักรธนบุรี<br></br>
              หน่วยการเรียนรู้ที่ 6 ภูมิปัญญาและศิลปวัฒนธรรมไทยสมัยอยุธยาและธนบุรี<br></br>
              หน่วยการเรียนรู้ที่ 7 บุคคลสำคัญสมัยอยุธยาและธนบุรี<br></br>
              หน่วยการเรียนรู้ที่ 8 พัฒนาการของภูมิภาคต่าง ๆ ในเอเชีย<br></br>
              หน่วยการเรียนรู้ที่ 9 แหล่งอารยธรรมโบราณในเอเชีย
              
            </Form>
            <h1 className="commingsoonstudy" >Coming soon</h1>
          </Form>        
        </Container>

        <div className="footer text-footer">
          <p>Surasak   Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>           
          <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
        </div>

      </div>
    )
  }
}

export default CreateStudy